import { Link } from "react-router-dom";
import * as React from "react";
import { ReactNode, useContext, useMemo } from "react";
import { ll_url } from "../../../utils/tools";
import { JobInfoContext } from "../../../job-info-context";

export function ViewerLink({zincId, children}: {zincId?: string, children?: ReactNode}) {
  const {id: jobId} = useContext(JobInfoContext);
  const viewerLink = useViewerLink(jobId, zincId);
  return (
    <Link to={viewerLink}>
      {children}
    </Link>
  )
}

export function useViewerLink(jobId: string, zincId?: string) {
  return useMemo(() => {
    const params = new URLSearchParams();
    if (zincId) {
      params.append('inhibitor', zincId);
    }
    let paramsStr = params.toString();
    if (paramsStr) {
      paramsStr = '?' + paramsStr;
    }
    return ll_url(`/viewer/${jobId}${paramsStr}`);
  }, [jobId, zincId]);
}